import styles from './YellowBadge.module.scss';

const YellowBadge = ({children}) => {
  return <div className={styles.badge}>
    {children}
  </div>
}

export default YellowBadge;